import { render, staticRenderFns } from "./plvPlayer.vue?vue&type=template&id=1b09c794&scoped=true&"
import script from "./plvPlayer.vue?vue&type=script&lang=js&"
export * from "./plvPlayer.vue?vue&type=script&lang=js&"
import style0 from "./plvPlayer.vue?vue&type=style&index=0&id=1b09c794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09c794",
  null
  
)

export default component.exports